import React from "react";
import { PlanYourVisitComp } from "../../components/planyourvisit/planyourvisitcomp";

const PlanYourVisit = () => {
    return (

        <>
            <PlanYourVisitComp />
        </>
    )
};

export default PlanYourVisit